import { Box, FormControlLabel, Grid, Radio } from "@mui/material";
import * as React from "react";
import * as taskService from "../../../models/services/taskService";
import { Translations } from "ui/Scripts/source/models/translations";
import { Dialog } from "../../framework/Dialog/Dialog";
import { GridRow } from "source/components/framework/Grid/GridRow";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { IdTitleDropdown } from "ui/Scripts/source/components/framework/Dropdown/IdTitleDropdown";
import { DialogButtons } from "source/components/framework/Dialog/DialogButtons";
import { ISessionState } from "../../../models/session/sessionState";
import { TaskDataRowList } from "../TaskDataRowList";
import { AppUtils } from "source/framework/appUtils";
import { useEffect, useState } from "react";
import { ITaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { FormCheckBox } from "source/components/framework/FormCheckBox";
import { VerticalContainer } from "ui/Scripts/source/components/framework/VerticalContainer";

interface ITaskTrashBinDialogProp {
    companyId: string;
    taskId: string;
    taskTypeId: string;
    sessionState: ISessionState;
    onOk: (rowAmount: number, selectedRowIds: string[], printRowInformation: boolean) => void;
    onClose: () => void;
}

export const TaskPrintDialog = (props: ITaskTrashBinDialogProp) => {
    const [printFirstRows, setPrintFirstRows] = useState(true);
    const [rowAmount, setRowAmount] = useState(10);
    const [taskType, setTaskType] = useState<ITaskEditTypeItem>(null);
    const [selectedRowIds, setSelectedRowIds] = useState<string[]>([]);
    const [printRowInformation, setPrintRowInformation] = useState(false);

    const loadData = async (id: string) => {
        const result = await AppUtils.callService(() => taskService.getTaskEditTypeItem(props.companyId, id), false);
        if (!result) return;
        setTaskType(result);
    };

    useEffect(() => {
        loadData(props.taskTypeId);
    }, [props.taskTypeId]);

    if (!taskType) return null;

    return (
        <Dialog
            id="taskPrintDialog"
            maxWidth="xl"
            maxHeight={!printFirstRows ? "calc(100vh - 200px)" : undefined}
            title={Translations.PrintTask}
            body={<VerticalContainer
                before={<>
                    <GridRow sx={{ mb: 2 }}>
                        <Grid item sm={6}>
                            <FormField title={Translations.RowsIncludedInPrint} fullWidth margin="0">
                                <Box style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
                                    <Box style={{ display: "flex", alignItems: "center" }}>
                                        <Radio
                                            checked={printFirstRows}
                                            onChange={(_e, checked: boolean) => { setPrintFirstRows(checked); }}
                                        />
                                        <Box
                                            sx={{ width: "250px" }}
                                            onClick={() => setPrintFirstRows(true)}
                                        >
                                            <IdTitleDropdown
                                                selectedId={rowAmount.toString(10)}
                                                items={[
                                                    { id: "0", title: Translations.NowRows },
                                                    { id: "10", title: `10 ${Translations.FirstRows.toLocaleLowerCase()}` },
                                                    { id: "20", title: `20 ${Translations.FirstRows.toLocaleLowerCase()}` },
                                                    { id: "50", title: `50 ${Translations.FirstRows.toLocaleLowerCase()}` },
                                                    { id: "100", title: `100 ${Translations.FirstRows.toLocaleLowerCase()}` },
                                                    { id: "250", title: `250 ${Translations.FirstRows.toLocaleLowerCase()}` },
                                                    { id: "500", title: `500 ${Translations.FirstRows.toLocaleLowerCase()}` },
                                                    { id: "1000", title: `1000 ${Translations.FirstRows.toLocaleLowerCase()}` }
                                                ]}
                                                onChange={(id) => setRowAmount(Number(id))}
                                            />
                                        </Box>
                                    </Box>
                                    <Box sx={{ minWidth: "200px", marginLeft: "11px" }}>
                                        <FormControlLabel
                                            label={Translations.PrintSelectedRows + (!printFirstRows ? ` (${selectedRowIds.length} ${Translations.Selected.toLocaleLowerCase()})` : "")}
                                            control={
                                                <Radio
                                                    checked={!printFirstRows}
                                                    onChange={(_e, checked: boolean) => { setPrintFirstRows(!checked); }}
                                                />
                                            }
                                        />
                                    </Box>
                                </Box>
                            </FormField>
                        </Grid>
                        {!printFirstRows &&
                            <Grid item sm={6}>
                                <FormField title="&nbsp;" fullWidth margin="0" padding="0 0 0 11px">
                                    <FormCheckBox
                                        title={Translations.PrintRowInformation}
                                        checked={printRowInformation}
                                        onChange={(checked) => setPrintRowInformation(checked)}
                                    />
                                </FormField>
                            </Grid>
                        }
                    </GridRow>
                </>}
                main={<>
                    {!printFirstRows &&
                        <TaskDataRowList
                            sessionState={props.sessionState}
                            isReadOnly={true}
                            companyId={props.companyId}
                            taskId={props.taskId}
                            dataId="X"
                            taskType={taskType}
                            onSetToolButtons={() => { }}
                            onSetCheckedIds={(checkedIds) => setSelectedRowIds(checkedIds)}
                        />
                    }
                </>}
            />}
            actions={
                <Box display="flex" justifyContent="end" width="100%">
                    <DialogButtons
                        saveTitle={Translations.Print}
                        onCancel={props.onClose}
                        onSave={() => props.onOk(printFirstRows ? rowAmount : 0, !printFirstRows ? selectedRowIds : [], !printFirstRows && printRowInformation)}
                    />
                </Box>
            }
            onClose={props.onClose}/>
    );
};